import React from "react";
import styled from "styled-components";

const AlternatingImageText = ({ data = {} }) => {
  const { sections = [] } = data;

  return (
    <Section>
      {sections.map((section, index) => (
        <SectionRow key={index}>
          <ContentContainer $reverse={index % 2 !== 0}>
            <ImageContainer>
              <img src={section.image} alt={section.imageAlt} />
            </ImageContainer>

            <TextContainer>
              <Title>{section.title}</Title>

              {section.description && (
                <Description>
                  {section.description.split("\n\n").map((paragraph, idx) => (
                    <React.Fragment key={idx}>
                      {paragraph}
                      {idx < section.description.split("\n\n").length - 1 && (
                        <>
                          <br />
                          <br />
                        </>
                      )}
                    </React.Fragment>
                  ))}
                </Description>
              )}

              {section.bullets && (
                <BulletList>
                  {section.bullets.map((bullet, idx) => (
                    <BulletItem key={idx}>{bullet}</BulletItem>
                  ))}
                </BulletList>
              )}
            </TextContainer>
          </ContentContainer>
        </SectionRow>
      ))}
    </Section>
  );
};

export default AlternatingImageText;

const Section = styled.section`
  background: #FFF;
  color: #000;
`;

const SectionRow = styled.div`
  padding: 80px 80px;
  @media (max-width: 768px) { padding: 60px 24px; }
`;

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;

  ${props => props.$reverse && `
    direction: rtl;
    & > * { direction: ltr; }
  `}

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    direction: ltr;
  }
`;

const ImageContainer = styled.div`
  height: 450px;
  position: relative;
  overflow: hidden;
  border-radius: 24px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  @media (max-width: 768px) { height: 350px; }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  font-size: 42px;
  color: #000;
  font-family: "Playfair Display", serif;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 20px;
  @media (max-width: 768px) { font-size: 32px; }
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 28px;
  color: #000000;
  opacity: 0.9;
  white-space: pre-line;
  margin-bottom: 32px;
  @media (max-width: 768px) { font-size: 16px; line-height: 24px; margin-bottom: 24px; }
`;

const BulletList = styled.ul`
  list-style-type: disc;
  padding-left: 24px;
  margin: 0;
`;

const BulletItem = styled.li`
  font-size: 16px;
  line-height: 28px;
  color: #000000;
  opacity: 0.9;
  margin-bottom: 16px;
  &:last-child { margin-bottom: 0; }
  @media (max-width: 768px) { line-height: 24px; }
`;
